export const editManagePlayerInputs = (skipEdit, changeRole, userFound, userName, userAccountNbr, role, updateType,
    loggedInAccountNbr, accountType, newAccountOwnerArr, loggedInUser, newAccountNbr, accountFound,
    loggedInAccountOwnerArr, loggedInRole ) => {
    // loggedInAccountNbr, accountType, loggedInUser, loggedInAccountOwnerArr, loggedInRole are for the individual who is logged on
    // userFound, userName, role and userAccountNbr are for the user name that has been entered 
    // newAccountOwnerArr, newAccountNbr and accountFound apply to the account number that has been entered.

    let firstChar = changeRole.substring(0,1).toUpperCase();
    const upperCaseChangeRole = firstChar + changeRole.substring(1, changeRole.length);
    firstChar = role.substring(0,1).toUpperCase();
    const upperCaseUserRole = firstChar + role.substring(1, role.length);
    
    let message = "";
    let accountNbrClass = "mt-2 text-left ml-4";
    let roleClass = "mt-2 text-left ml-4";
    let updateTypeClass = "font-weight-bold";
    let newAccountNbrClass = "font-weight-bold";
    let userNameClass = "font-weight-bold";
    let displayAccountNbr = "";
    let errorsFound = true;
    if (userFound === true){
        switch (true){
            case (updateType === "" || updateType === "none"):
                // Rule 1
                message = "Must select a Type of Change.";
                updateTypeClass += " text-danger";
                break;
            case (updateType === "add" && userAccountNbr === loggedInAccountNbr && skipEdit === false &&
                (changeRole !== "teacher" || (changeRole === "teacher" && role === "teacher")) &&
                (changeRole !== "parent" || (changeRole === "parent" && role === "parent"))):
                // Rule 2
                //  note:  if the individual is already in this account but their role is not 'teacher
                //    then it is not an error, this process will change the person's role to teacher
                //    but only if the changeRole is 'teacher' - did not make this exception for a Parent
                //    because they can just remove and then re-add for a parent (may not work for a teacher
                //    due to multiple accounts for a teacher).  Same rule added for parent as for teacher.
                message = upperCaseChangeRole + " already belongs to this " + accountType;
                displayAccountNbr = userAccountNbr;
                accountNbrClass += " text-danger";
                break;
            case (changeRole === "player" && skipEdit === false && updateType === "remove" && 
                (role === "teacher" || role === "parent")):
                // Rule 3 
                //  if the changeRole is 'teacher' or parent then cannot remove using the 'managePlayers" option
                message = "This individual is a " + role + " and cannot be removed from a " + accountType + " using " +
                    "this process.";
                if (userAccountNbr === loggedInAccountNbr){
                    displayAccountNbr = userAccountNbr;
                }else{
                    displayAccountNbr = "Assigned to Another Account"
                }
                roleClass += " text-danger";
                break;
            case (role !== changeRole && skipEdit === false && updateType === "add" && role !== "player"): 
                // Rule 4
                //  if the changeRole is 'teacher' or parent then can change a player to a teacher/parent via this process
                message = "This individual is a " + role + " and cannot be added to a " + accountType + " as a " +
                    changeRole + ".";
                if (userAccountNbr === "Individual"){
                    displayAccountNbr = "Unassigned";
                }else{
                    displayAccountNbr = "Assigned to Another Account"
                }
                roleClass += " text-danger";
                break;
            case (updateType === "switch" && accountFound === false):
                // Rule 5
                message = "New " + accountType + " Code is not valid.";
                if (userAccountNbr === "Individual"){
                    displayAccountNbr = "Unassigned";
                }else{
                    if (newAccountOwnerArr.includes(loggedInUser)){
                        displayAccountNbr = userAccountNbr;
                    }else{
                        displayAccountNbr = "Assigned to a Different " + accountType;
                    }
                }
                newAccountNbrClass += " text-danger";
                break;
            case ((updateType === "switch" || updateType === "remove") && userAccountNbr !== loggedInAccountNbr):
                // Rule 6
                message = "Individual is not currently in this " + accountType + ".";
                if (userAccountNbr === "Individual"){
                    displayAccountNbr = "Unassigned";
                }else{
                    if (newAccountOwnerArr.includes(loggedInUser)){
                        displayAccountNbr = userAccountNbr;
                    }else{
                        displayAccountNbr = "Assigned to a Different " + accountType;
                    }
                }
                userNameClass += " text-danger";
                break;
            case (userAccountNbr !== "Individual" && userAccountNbr !== loggedInAccountNbr && 
                changeRole !== "teacher" && skipEdit === false):
                // Rule 8
                // it is ok for a teacher to be assigned to multiple accounts (see prev edit for exception)
                message = upperCaseUserRole + " is currently assigned to a different class or household.";
                if (updateType === "add"){
                    displayAccountNbr = "Already Assigned";
                }else{
                    if (updateType === "switch"){
                        if (newAccountOwnerArr.includes(loggedInUser)){
                            displayAccountNbr = userAccountNbr ;
                            
                        }else{
                            displayAccountNbr = "Not Assigned to One of Your Classes";
                        }
                    }else{
                        displayAccountNbr = "Not Assigned to " + loggedInAccountNbr ;
                    }
                }
                accountNbrClass += " text-danger";
                break;
            case (updateType === "switch" && (!newAccountNbr || newAccountNbr === "")):
                // Rule 10
                message = "New " + accountType + " Code is required for a switch.";
                newAccountNbrClass = " text-danger";
                break;
            case (updateType === "switch" && userAccountNbr === newAccountNbr):
                // Rule 11
                message = "This " + changeRole + " is already assigned to this " + accountType;
                newAccountNbrClass += " text-danger";
                displayAccountNbr = newAccountNbr;
                break;
            case (updateType === "switch" && accountFound === true && 
                !newAccountOwnerArr.includes(loggedInUser) && skipEdit === false):
                // Rule 12
                message = "Change not allowed.  You are not one of the " + loggedInRole + "s of the new " + accountType + 
                    " Code for this change.";
                if (userAccountNbr === loggedInAccountNbr){
                    displayAccountNbr = userAccountNbr;
                }else{
                    displayAccountNbr = "Assigned to another class";
                }
                newAccountNbrClass += " text-danger";
                break;
            case ((changeRole === "teacher" || changeRole === "parent") && 
                  (updateType === "switch" || updateType === "remove") &&
                   loggedInAccountOwnerArr.find(elem => elem.username === loggedInUser) === undefined &&
                   loggedInAccountOwnerArr.length <= 1):
                   // Rule 13
                       message = "Cannot remove this individual from this account as it is the only " +
                        changeRole + " assigned to the account.";
                       displayAccountNbr = loggedInAccountNbr;
                       newAccountNbrClass += " text-danger"; 
                break;
            default:   // no errors found //
                switch (true){
                    case (skipEdit === true || updateType === "switch" || updateType === "remove"):
                        displayAccountNbr = userAccountNbr;
                        break;
                    case newAccountOwnerArr.includes(loggedInUser):
                        displayAccountNbr = userAccountNbr;
                        break;
                    case userAccountNbr === loggedInAccountNbr:
                        displayAccountNbr = loggedInAccountNbr;
                        break;
                    case userAccountNbr !== "Individual":
                        displayAccountNbr = "Assigned to Another " + accountType;
                        break;
                    default:
                        displayAccountNbr = "Unassigned";
                        break;
                }
                message = "Entries are valid, click the 'Confirm' button to finish update.";
                errorsFound = false;
                break;     
        }
    }else{
        if (!userName || userName === ""){
            // Rule 15
            message = upperCaseChangeRole + " Name is a Required Entry.";
        }else{
            // Rule 16
            message = upperCaseChangeRole + " Name entered was not found";
        }
        userNameClass += " text-danger";
    }
    const returnObj = {errorsFound: errorsFound, message: message, displayAccountNbr: displayAccountNbr,
        accountNbrClass: accountNbrClass, roleClass: roleClass, newAccountNbrClass: newAccountNbrClass,
        updateTypeClass: updateTypeClass, userNameClass: userNameClass
    }
    return returnObj;
}
export default editManagePlayerInputs;